import { createApp } from "vue";
import svgSprite from "@shared_components/svgSprite.js";
import App from "./App.vue";
import { mountConfig } from "../support_auth_shared/page.js";

// The sign-in page (support/views/login.php) on the lean signed-out layout.
// A plain Vue app: the page is public and has none of the admin chrome.
// What the view put on the element holds nothing secret (see the view).
const config = mountConfig("#loginApp");

createApp(App, { config }).use(svgSprite).mount("#loginApp");
